import PropTypes from 'prop-types';
import { useChannelCreated } from '../../../Slice';

function ChannelCreated({ channelId }) {
   const createdAt = useChannelCreated(channelId);

   const formatCreationDate = dateString => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `Created on ${date.toLocaleDateString('en-GB', {
         day: '2-digit',
         month: '2-digit',
         year: 'numeric',
      })}`;
   };

   return <p className="creation-date">{formatCreationDate(createdAt)}</p>;
}

export default ChannelCreated;

ChannelCreated.propTypes = {
   channelId: PropTypes.string,
};
